import { customSequenceTypes } from '../../constants/retention';
import * as api from '../../api/retention';
import { retentionEventFilterActions } from '../../constants/filter';
import { asyncAction } from '../common';

export const changeRetentionComplexView = (view) => ({
  type: 'CHANGE_RETENTION_COMPLEX_VIEW',
  view,
});

export const toggleRetentionTrendLine = () => ({
  type: 'TOGGLE_RETENTION_COMPLEX_TREND_LINE',
});

export const toggleRetentionAverageLine = () => ({
  type: 'TOGGLE_RETENTION_COMPLEX_AVERAGE_LINE',
});

export const toggleRetentionMedianLine = () => ({
  type: 'TOGGLE_RETENTION_COMPLEX_MEDIAN_LINE',
});

export const toggleRetentionAdaptive = () => ({
  type: 'TOGGLE_RETENTION_COMPLEX_ADAPTIVE',
});

export const changeFirstEvent = (event, eventMetainf) => ({
  type: 'CHANGE_RETENTION_COMPLEX_FIRST_EVENT',
  event,
  eventMetainf,
});

export const changeReturnEvent = (event, eventMetainf) => ({
  type: 'CHANGE_RETENTION_COMPLEX_RETURN_EVENT',
  event,
  eventMetainf,
});

export const changeDimensionType = (dimensionType) => ({
  type: 'CHANGE_RETENTION_COMPLEX_DIMENSION_TYPE',
  dimensionType,
});

export const addFilterClause = (eventIndex) => ({
  type: retentionEventFilterActions.ADD_FILTER_CLAUSE,
  eventIndex,
});

export const removeFilterClause = (eventIndex, id) => ({
  type: retentionEventFilterActions.REMOVE_FILTER_CLAUSE,
  id,
  eventIndex,
});

export const setFilterClauseField = (eventIndex, id, field, type) => ({
  type: retentionEventFilterActions.SET_FILTER_CLAUSE_FIELD,
  id,
  field,
  eventIndex,
  fieldType: type,
});

export const setFilterClauseValue = (eventIndex, id, value) => ({
  type: retentionEventFilterActions.SET_FILTER_CLAUSE_VALUE,
  id,
  value,
  eventIndex,
});

export const setClausesConcatOperator = (eventIndex, value) => ({
  type: retentionEventFilterActions.SET_CLAUSES_CONCAT_OPERATOR,
  value,
  eventIndex,
});

export const setFilterClauseOperator = (eventIndex, id, value, resetClauseValue) => ({
  type: retentionEventFilterActions.SET_FILTER_CLAUSE_OPERATOR,
  id,
  value,
  resetClauseValue,
  eventIndex,
});

export const toggleCustomSequence = () => ({
  type: 'TOGGLE_RETENTION_COMPLEX_CUSTOM_SEQUENCE',
});

export const setCustomSequenceType = (customSequenceType) => (dispatch) => {
  dispatch({
    type: 'SET_RETENTION_COMPLEX_CUSTOM_SEQUENCE_TYPE',
    customSequenceType,
  });

  if (customSequenceType === customSequenceTypes.RANGE) {
    dispatch({
      type: 'CALCULATE_RETENTION_COMPLEX_CUSTOM_SEQUENCE',
    });
  }
};

export const changeCustomSequence = (customSequence) => ({
  type: 'CHANGE_RETENTION_COMPLEX_CUSTOM_SEQUENCE',
  customSequence,
});

export const setCustomSequenceFrom = (from = 0) => ({
  type: 'SET_RETENTION_COMPLEX_CUSTOM_SEQUENCE_FROM',
  from,
});

export const setCustomSequenceTo = (to = 0) => ({
  type: 'SET_RETENTION_COMPLEX_CUSTOM_SEQUENCE_TO',
  to,
});

export const calculateCustomSequence = () => ({
  type: 'CALCULATE_RETENTION_COMPLEX_CUSTOM_SEQUENCE',
});

export const setFilterVisibility = (eventIndex, value) => ({
  type: retentionEventFilterActions.SET_FILTER_VISIBILITY,
  eventIndex,
  value,
});

export const removeFilter = (eventIndex) => ({
  type: retentionEventFilterActions.REMOVE_FILTER,
  eventIndex,
});

export const copyFilter = (eventIndex, clauses) => ({
  type: retentionEventFilterActions.COPY_FILTER,
  eventIndex,
  clauses,
});

export const setRetentionComplexExposureError = (error) => ({
  type: 'SET_RETENTION_COMPLEX_EXPOSURE_ERROR',
  error,
});

export const setRetentionComplexExecuteId = (executeId) => ({
  type: 'SET_RETENTION_COMPLEX_EXECUTE_ID',
  executeId,
});

export const executeRetentionComplex = (executeId) =>
  asyncAction('EXECUTE_RETENTION_COMPLEX_QUERY', api.executeRetentionComplexQuery(executeId));

export const exposeRetentionQuery = () =>
  asyncAction('EXPOSE_RETENTION_COMPLEX_QUERY', api.exposeRetentionComplexQuery());

export const executeRetentionComplexCsv = () =>
  asyncAction('EXECUTE_RETENTION_COMPLEX_QUERY_CSV', api.executeRetentionComplexCsv());
